import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import { ModalProvider } from "./components/ui/ModalProvider";
import "./styles/tailwind.css";
import "./styles/index.css";

const container = document.getElementById("root");
const root = createRoot(container);

root.render(
  <ModalProvider>
    <App />
  </ModalProvider>
);

// ✅ Start background FIFO worker for wp_articles queue
import "./services/articleQueueWorker";
